<template>
    <div class="row-cont" >
        <v-menu open-on-hover close-on-click offset-y>
            <template v-slot:activator="{on, attrs}">
                <v-chip
                    outlined
                    text
                    v-bind="attrs"
                    v-on="on"
                >
                {{ username }}
                <v-icon right>mdi-menu-down</v-icon>
                </v-chip>
            </template>
            <v-list>
                <v-list-item @click="$emit('spotClick')">
                    <v-list-item-title><v-icon left>mdi-card-account-details-outline</v-icon>My spot</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('historyClick')">
                    <v-list-item-title><v-icon left>mdi-credit-card-outline</v-icon>Invoice history</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('accountClick')">
                    <v-list-item-title><v-icon left>mdi-account</v-icon>Edit account</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('logout')">
                    <v-list-item-title><v-icon left>mdi-exit-to-app</v-icon>Logout</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: "UserDropdownComponent",
    props: {
        username: String
    },
    data() {
        return {
            openMenu: false
        }
    }
};
</script>

<style lang="scss" scoped>
    .row-cont {
        position: relative;
        display: flex;
        height: 50px;
        max-width: 250px;
        align-items: center;
        cursor: pointer;
    }
</style>